import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import PlayerSampleView from '../../../types/player/PlayerSampleView';

@Injectable({
    providedIn: 'root'
})
export class PlayerService {

    private baseUrl = environment.apiUrl;
    private RESOURCE = 'player';

    constructor(private http: HttpClient) {
    }

    /**
     * Get sample view
     *
     * @param token The token to access the API.
     * @return The sample view data.
     */
    public async getSampleView(token: string): Promise<PlayerSampleView> {
        try {
            return new PlayerSampleView(
                await this.get<PlayerSampleView>(this.RESOURCE + '/sample', new HttpParams().set('token', token)));
        } catch (error) {
            console.error('Failed to get sample view:', error);
            throw error;
        }
    }

    /**
     * Create headers for the request.
     *
     * @param contentType The content type of the request.
     * @return The headers for the request.
     */
    private createHeaders(contentType: string = 'application/json'): HttpHeaders {
        const headersConfig: { [key: string]: string } = {
            'Content-Type': contentType,
        };

        return new HttpHeaders(headersConfig);
    }

    /**
     * Handle the URL for the request.
     *
     * @param endpoint The endpoint to access.
     * @return The URL for the request.
     */
    private handleUrl(endpoint: string): string {
        return `${ this.baseUrl }/${ endpoint }`;
    }

    private async get<T>(endpoint: string, params?: HttpParams): Promise<T> {
        const url = this.handleUrl(endpoint);
        return await lastValueFrom(
            this.http.get<T>(url, { headers: this.createHeaders(), params })
        );
    }
}
